import { useCallback } from 'react';
import { Accordion, IAccordionItemProps, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { useApplicationContext } from 'shared/common/utils/applicationContext';
import { clickFaqAgentCommission } from 'shared/landingSeller/components/tracking';
import { FAQ } from 'shared/landingSeller/constants/faq';
import * as style from '../../components/Faq/styles.css';

export const FaqContainer: React.FC = () => {
  const device = useDeviceType();
  const { custom } = useApplicationContext();

  const handleItemClick = useCallback(
    (item: IAccordionItemProps, index: number, open: boolean) => {
      if (index === 0 && item.title === 'Как работает гарантия безопасности сделки?' && open) {
        clickFaqAgentCommission(custom);
      }
    },
    [custom],
  );

  return (
    <div className={clsx(style['container'], style[device])}>
      <div className={style['title']}>Вопросы и ответы</div>
      <Accordion
        size={device === 'phone' ? 'S' : 'M'}
        items={FAQ}
        onItemClick={args => handleItemClick(args.target, args.index, args.open)}
      />
    </div>
  );
};
